import React from "react";
import "../Component/Component.css/GramFooter.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export default function GramFooter() {
  return (
    <footer className="footer-container">
      <div className="footer-grid">

        {/* LEFT SECTION */}
        <div className="footer-left">
          <h2 className="titlef">ग्रामपंचायत नागठाणे</h2> 
          <p className="subtitlef">मू.पो नागठाणे ता- जि सातारा</p>

          <h3 className="section-titlef">संपर्क माहिती</h3>

          <p className="location-row">
            <FontAwesomeIcon icon={faLocationDot} className="icon" />
            ग्रामपंचायत कार्यालय, नागठाणे
          </p>

          <p className="address-text">
            नागठाणे, तालुका – सातारा, जिल्हा – सातारा, महाराष्ट्र – (४१५ ५१९)
          </p>

<div></div>
          <div className="contact-block">
            <div className="contact-row">
              <FontAwesomeIcon icon={faPhone} className="icon" />
              <p><b>फोन:</b> +९१९८२३५९९२०५</p>
            </div>

            <div className="contact-row">
              <FontAwesomeIcon icon={faEnvelope} className="icon" />
              <p><b>ईमेल:</b>info@grampanchayatnagthane.in</p>
            </div>
          </div>
        </div>

        {/* MIDDLE SECTION */}
        <div className="footer-middle">
          <h2 className="section-titlef">झटपट दुवे</h2>
          <ul className="link-list">
            <li><Link to="/">मुखपृष्ठ</Link></li>
            <li><Link to="/about">आमच्याविषयी</Link></li>
            <li><Link to="/achievements">यशोगाथा</Link></li>
            <li><Link to="/gallery">गॅलरी</Link></li>
            <li><Link to="/campaign">मुख्यमंत्री अभियान</Link></li>
            <li><Link to="/contact">संपर्क</Link></li>
          </ul>
        </div>

        {/* RIGHT SECTION */}
        <div className="footer-right">
          <h2 className="section-titlef">कार्यालयीन वेळा</h2>
          <p className="office-text">
            महिन्यातील प्रत्येक सोमवार ते शुक्रवार<br />
            सकाळी ०९.४५ ते संध्याकाळी ६.१५
          </p>
          <p className="holiday">रविवार: बंद</p>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
       <p>
          ©2025 by grampanchayatnagthane. Proudly created by{" "}
          <a 
            href="https://designvio.in/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            DesignVio
          </a>
        </p>
        <div className="footer-links">
          <span>Privacy Policies</span>
          <span>Terms and Conditions</span>
        </div>
      </div>
    </footer>
  );
}
